import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {CONTROL_RATIO_SLICE} from './control-ratio-slice-constants';
import {IControlRatioSliceState} from './control-ratio-slice-types';

export const controlRatioSlice = createSlice({
    name: CONTROL_RATIO_SLICE,
    initialState: {
        formAdditionalParameters: null,
    } as IControlRatioSliceState,
    reducers: {
        setFormAdditionalParameters(state, {payload}: PayloadAction<Record<string, any>>) {
            state.formAdditionalParameters = payload;
        },
        resetFormAdditionalParameters(state) {
            state.formAdditionalParameters = null;
        },
    },
});

const selectControlRatioSliceState = (state: TAppState) => state[CONTROL_RATIO_SLICE];

export const controlRatioSelectors = {
    selectFormAdditionalParameters: createSelector(
        selectControlRatioSliceState,
        state => state.formAdditionalParameters,
    ),
};

export const {
    reducer: controlRatioReducer,
    actions: controlRatioActions,
} = controlRatioSlice;
